/* eslint-disable */
<template>
  <div class="table-toolbar">
    <v-card class="mobile-height" elevation="0">
      <v-card-title class="main-toolbar">


          <!--action buttons-->
          <div class="actions" >
            <!--<div class="padding-right" v-if="activeViewAdmin === 'Schools'">-->
            <!--  <v-btn  text  class="branded-background text-white" @click="handleDialogOpen({type:'addSchool' , data:{}})" v-if="selectedDataAdmin.length === 0">Add Organization</v-btn>-->
            <!--  <v-btn  text  class="branded-background text-white" @click="handleDialogOpen({type:'editSchool' , data:{schools:selectedDataAdmin}})" v-if="selectedDataAdmin.length > 0">{{(this.selectedDataAdmin.length === 1) ? 'Edit Organization' : 'Edit Organizations'}}</v-btn>-->
            <!--</div>-->


            <div class="padding-right"  v-if="activeViewAdmin === 'Instructors'">
              <v-btn  text  class="branded-background text-white" @click="handleDialogOpen({type:'addInstructors' , data:{}})" v-if="selectedDataAdmin.length === 0">Add Instructors</v-btn>
              <v-btn  text  class="branded-background text-white" @click="handleDialogOpen({type:'editInstructors' , data:{instructors:selectedDataAdmin}})" v-if="selectedDataAdmin.length > 0">{{(this.selectedDataAdmin.length === 1) ? 'Edit Instructor' : 'Edit Instructors'}}</v-btn>
            </div>


            <div class="padding-right" v-if="activeViewAdmin === 'Bulbs' && adminData.hosting && !adminData.hasLimitedVideoUploadAccess">
              <v-btn  text  class="branded-background text-white"  @click="handleDialogOpen({type:'addVideo', data:{}})">Upload Video</v-btn>
            </div>

            <div class="padding-right" v-if="activeViewAdmin === 'Bulbs' && (!adminData.hosting || adminData.hasLimitedVideoUploadAccess)">
              <Tooltip top>
                <v-btn text class="branded-background text-white">Upload Video</v-btn>
                <template v-slot:text>
                  HLS video upload not allowed. Please contact PlayPosit to upgrade.
                </template>
              </Tooltip>
            </div>

            <div class="padding-right " v-if="activeViewAdmin === 'Treeview' && selectedNode.name " >
              <v-icon   class="branded-text pr-1">folder</v-icon>  
              <i class="el-icon el-icon-arrow-right"></i>
                  <span>{{truncateFolderName(selectedNode.name, 20)}}</span> 
                  <el-dropdown :hide-on-click="false" @command="handleCommand">
                  <v-icon class="el-dropdown-link more-icon">more_vert</v-icon>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="checkTreeviewAddFolderPermission()" command="addFolder">Add Folder</el-dropdown-item>
                    <el-dropdown-item :disabled="checkTreeviewAddFolderPermission()" command="editFolder">Edit Folder </el-dropdown-item>
                    <v-tooltip right v-if="selectedNode.parentId != null && checkSubContent()" >
                      <template slot="activator">
                        <el-dropdown-item :disabled="checkSubContent()" command="removeFolder">Remove Folder</el-dropdown-item>
                      </template>
                      <span style="color:#fff" v-if="!selectedNode.schoolId" >Folder must be empty before it can be removed.</span>
                      <span style="color:#fff" v-if="selectedNode.schoolId" >Child school root folders cannot be deleted.</span>
                    </v-tooltip>
                    <el-dropdown-item v-if="selectedNode.parentId != null && !checkSubContent()" command="removeFolder">Remove Folder</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> 
            </div>
            <v-btn v-if="Object.keys(adminFilters).length > 0" text class="branded-border branded-text white-background" @click="clearAllFilters">Clear Filters</v-btn>
          </div>
          <!--data manipulation buttons-->
          <div class="data-manipulation flex">
            <v-btn 
              v-if="selectedDataAdmin.length > 0 && ['Bulbs', 'Treeview'].includes(activeViewAdmin)"
              class="branded-text"
              :disabled="selectedDataAdmin.length > 50"
              text
              flat
              @click="slideOut({ toggle: true, view: 'batchCopy', bulbs: selectedDataAdmin })">
              Batch Copy
            </v-btn>
            <v-btn 
              v-if="selectedDataAdmin.length > 0 && ['Bulbs', 'Treeview'].includes(activeViewAdmin)"
              class="branded-text"
              :disabled="selectedDataAdmin.length > 50"
              text
              flat
              @click="slideOut({ toggle: true, view: 'batchSettings', location: 'Admin-Media-Library', bulbs: selectedDataAdmin });">
              Batch Settings
            </v-btn>
            <v-btn
              v-if="(
                selectedDataAdmin.length > 0
                && ['Bulbs', 'Treeview'].includes(activeViewAdmin)
              )"
              color="error"
              text
              flat
              @click="handleDialogOpen({
                type: 'remove' ,
                data: selectedDataAdmin.map((bulb) => bulb.id)
              })"
            >
              Delete
            </v-btn>
            <v-spacer></v-spacer>
            <div  v-if="
              (
              activeViewAdmin === 'Bulbs'
              || activeViewAdmin === 'Treeview' 
              || activeViewAdmin === 'Schools-Bulbs'
              ) && 
              selectedDataAdmin.length === 0
              " style="width: 150px; ">
              <v-menu
                :close-on-content-click="false"
                :nudge-width="360"
                attach
                nudge-left="330"
                z-index="11"
              >
                <v-btn name="filter"  flat slot="activator" :class="[activeViewAdmin === 'Treeview' ? 'treeViewButton' : '']"  class="branded-text " @click="setTreeView">
                  <v-icon class="pr-1">account_tree</v-icon>
                 Tree View
                </v-btn>

              </v-menu>
            </div>
            
            <div v-if="
              ( activeViewAdmin === 'Bulbs' 
              || activeViewAdmin === 'Schools-Bulbs'  
              || activeViewAdmin === 'Treeview' 
              || activeViewAdmin === 'Instructors'
              ) && 
              selectedDataAdmin.length === 0
              " style="width: 175px; ">
              <v-menu
                v-model="popoverToggles.adminFilterMenu"
                :close-on-content-click="false"
                :nudge-width="360"
                attach
                ref="adminFilterMenu"
                :nudge-left="adminFilterMenuNudgeLeft"
                z-index="11"
              >
                <template v-if="activeViewAdmin === 'Instructors'">
                  <v-btn name="filter" flat slot="activator" class="branded-text">
                    <v-icon style="padding-right:5px;">filter_list</v-icon>
                    Filter
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn name="filter" flat slot="activator" class="branded-text">
                    <v-icon style="padding-right:5px;">filter_list</v-icon>
                    Search/Filter
                  </v-btn>
                </template>
                <Popover
                  v-if="popoverToggles.adminFilterMenu"
                  id="dash-popovers"
                  tabindex="-1"
                  type="adminFilters">
                </Popover>
              </v-menu>
            </div>

            <div class="search" @submit.prevent="search" v-if="activeViewAdmin != 'Bulbs' && activeViewAdmin != 'Schools-Bulbs' && activeViewAdmin != 'Treeview'">
              <v-form class="search-form tabable">
                <v-text-field
                v-model="queryParamsAdmin.search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
                @click:append="search"
                @click:clear="clearSearch"
                @paste="pasteSearch"
                clearable
                :disabled="adminAjaxing || selectedDataAdmin.length > 0"
                ></v-text-field>
              </v-form>
            </div>

            <div class="center-btn">
              <v-btn :disabled ="adminAjaxing || selectedDataAdmin.length > 0" name="refresh" icon @click="refresh" class="tabable refresh" tabindex=0 aria-label="Refresh table">
                <Tooltip top>
                  <v-icon>refresh</v-icon>
                  <template v-slot:text>
                    Refresh Data
                  </template>
                </Tooltip>
              </v-btn>
            </div>
            <!-- Begin Data Export -->
            <v-btn name="export" flat icon class="branded-text export-button"
              @click="handleDialogOpen({
                type: 'export',
                data: {
                  analytics: false,
                  bulb_name: '',
                  bulb_id: '',
                  isAdmin : true
                }
              })"
              :disabled="adminAjaxing"
              v-if="activeViewAdmin === 'Instructors'">
              <Tooltip top>
                <v-icon>cloud_download</v-icon>
                <template v-slot:text>
                  Data Export
                </template>
              </Tooltip>
            </v-btn>
          </div>
        </v-card-title>
        <div class="filters" v-if="(activeViewAdmin === 'Instructors' || activeViewAdmin === 'Bulbs' || activeViewAdmin === 'Treeview' )  &&  Object.keys(adminFilters).length > 0">
            <span style="margin-left: 5px; width:80px; min-width: 80px;">Filtered by:</span>
            <div class="filters-overflow">
              <v-chip color="white" v-for="(value, key) in adminFilters" :key="key" class="chip-container">
                <span :style="tagTextStyle(key)">{{key.replace('-', ' ')}}:</span>
                <v-chip v-for="(item, index) in adminFilters[key]" :style="tagStyle(key)" :key="index" close @input="clearFilter([key, item])">
                  <span :style="tagTextStyle(key)">{{item}}</span>
                </v-chip>
              </v-chip>
            </div>
        </div>
      </v-card>
  </div>
</template>

<script>
import Color from 'color';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Popover from '../Popover';

export default {
  name: 'admin-table-toolbar',
  components: {
    Popover,
  },
  data() {
    return {
      adminFilterMenuContentType: 'Bulbs',
      adminFilterMenuNudgeLeft: 330,
      dialogData: {},
      lmsImg: 'https://res.cloudinary.com/dkyxchav6/image/upload/v1547491036/lms_default.png',
      windowInnerWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapState('admin', [
      'adminFilterContentType',
    ]),
    ...mapGetters([
      'activeView',
      'breadcrumbs',
      'dialogShow',
      'instructorData',
      'popoverToggles',
      'nodeApiPrefix',
      'breadcrumbs',
      'designerApiPrefix',
      'adminData',
      'school'
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'tags'
    ]),
    ...mapGetters('admin', [
      'activeViewAdmin',
      'adminAjaxing',
      'queryParamsAdmin',
      'selectedDataAdmin',
      'adminFilterSearch',
      'refreshDataAdmin',
      'selectedNode',
      'bulbs',
      'treeSubNodeData',
      'adminFilterSearch',
    ]),
    searchWatch: function() {
      //returns search query param
      return this.queryParamsAdmin.search;
    },
    adminFilters: function(){
      let obj = {}
      if(Object.keys(this.adminFilterSearch.creator).length > 0) {
        obj['Creator'] = [this.adminFilterSearch.creator.name];
      }
      if(this.adminFilterSearch.organization.length > 0) {
        obj['Organization'] = [];
        this.adminFilterSearch.organization.forEach((item, index) => {
          obj['Organization'].push(item.text);
        })
      }
      if(this.adminFilterSearch.name.length > 0) {
        obj[`${this.adminFilterContentType === 'Bulbs' ? 'Bulb' : 'Playlist'}-Name`] = [];
        this.adminFilterSearch.name.forEach((item, index) => {
          obj[`${this.adminFilterContentType === 'Bulbs' ? 'Bulb' : 'Playlist'}-Name`].push(item);
        })
      }
      if(this.adminFilterSearch.instructor.length > 0) {
        obj['Creator-Name'] = [];
        this.adminFilterSearch.instructor.forEach((item, index) => {
          obj['Creator-Name'].push(item);
        })
      }
      if(this.adminFilterSearch.age.length > 0) {
        obj['Audience'] = [];
        this.adminFilterSearch.age.forEach((item, index) => {
          obj['Audience'].push(item);
        })
      }
      if(this.adminFilterSearch.subject.length > 0) {
        obj['Subject'] = [];
        this.adminFilterSearch.subject.forEach((item, index) => {
          obj['Subject'].push(item);
        })
      }
      if(this.adminFilterSearch.keywords.length > 0){
        obj['Keywords/Tags'] = [];
        this.adminFilterSearch.keywords.forEach((item, index) => {
          obj['Keywords/Tags'].push(item);
        })
      }
      if (this.adminFilterSearch.excludeTags.length > 0) {
        obj['Exclude Tags'] = [];
        this.adminFilterSearch.excludeTags.forEach((item, index) => {
          obj['Exclude Tags'].push(item);
        })
      }
      if(this.adminFilterSearch.youtube != ''){
        obj['Youtube-Video'] = [`...${this.adminFilterSearch.youtube}`];
      }
      if(this.adminFilterSearch.course && this.adminFilterSearch.course.length > 0){
        obj['Course']=[];
        this.adminFilterSearch.course.forEach((item, index) => {
          obj['Course'].push(item.name);
        })
      }
      if(this.adminFilterSearch.adminOnly) {
        obj['All-Instructors']=[];
        obj['All-Instructors'].push('Admin only')
      }
      if(this.adminFilterSearch.bulbId.length > 0) {
        obj['Bulb-Id'] = [];
        this.adminFilterSearch.bulbId.forEach((item) => {
          obj['Bulb-Id'].push(item);
        });
      }
      return obj;
    },
  },
  methods: {
    ...mapActions('instructors', [
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'slideOut',
      'triggerSnackbar',
      'setDashLoading',
    ]),
    search: function(){
      //updates data and url based on search
      this.$store.commit('admin/setQueryParams', {page:1, per_page: 20});
      this.$store.dispatch('admin/getTableData');
      this.$store.dispatch('admin/updateUrl');
    },
    clearSearch: function(){
      this.$store.commit('admin/setQueryParams', {search:""});
      this.$store.dispatch('admin/updateUrl');
      this.$store.dispatch('admin/getTableData');
    },
    refresh: function(){
      //updates data
      this.$store.dispatch('admin/getTableData');
    },
    clearFilter: function(type){
       //reset query params for filter change and update url
      let params = {sort:'', page:1, per_page:20, search: ''}
      if(type[0] === 'Organization'){
        params.school_id = 0;
      }
      if(type[0] === 'All-Instructors'){
        params.adminOnly = false;
      }
      this.$store.commit('admin/setQueryParams', params);
      this.$store.dispatch('admin/updateUrl');
      this.$store.commit('admin/clearFilter', type);
    },
    clearAllFilters: function(){
       //reset query params for filter change and update url
      this.$store.commit('admin/setQueryParams', {sort:'', page:1, per_page:20, search: ''});
      this.$store.dispatch('admin/updateUrl');

      this.$store.commit('admin/clearAllFilters');
    },
    tagStyle: function(type){
      let color;

      if(type === 'Creator' || type === 'Creator-Name'){
        color = '#b2ebf2'
      } else if(type === 'Bulb-Name' || type === 'Playlist-Name') {
        color = '#DCEDC8'
      } else if(type === 'Youtube-Video') {
        color = '#D7CCC8'
      } else if(type === 'Organization') {
        color = '#E1BEE7'
      } else if(type === 'Audience') {
        color = '#e6f0f4'
      } else if(type === 'Subject') {
        color = '#e8e6f4'
      } else if(type === 'Keywords/Tags') {
        color = '#fafafa'
      } else  {
        color = '#fafafa'
      }

      let darkColor = Color(color).darken(0.60).hex();
      return {
        'backgroundColor': color,
        'color': `${darkColor} !important`,
        'border': `solid 1px ${darkColor} !important`,
      }
    },
    tagTextStyle: function(type){
      let color;
      let category;

      if(type === 'Creator' || type === 'Creator-Name'){
        color = '#b2ebf2'
      } else if(type === 'Bulb-Name' || type === 'Playlist-Name') {
        color = '#DCEDC8'
      } else if(type === 'Youtube-Video') {
        color = '#D7CCC8'
      } else if(type === 'Organization') {
        color = '#E1BEE7'
      } else if(type === 'Audience') {
        color = '#e6f0f4'
      } else if(type === 'Subject') {
        color = '#e8e6f4'
      } else if(type === 'Keywords/Tags') {
        color = '#fafafa'
      } else  {
        color = '#fafafa'
      }

      let darkColor = Color(color).darken(0.60).hex();
      return {
        'color': `${darkColor} !important`,
      }
    },
    setTreeView: function(){
      this.clearAllFilters();
      if(this.activeViewAdmin === "Treeview"){
        this.$store.commit('admin/setActiveView', ["Bulbs"]);
        this.$store.commit('admin/setAdminNodeIdFilter', {
            nodeId: ''
        })
      }else{
        this.$store.commit('admin/setActiveView', ["Treeview"]);
        this.$store.commit('admin/clearBulbData');
        this.$store.dispatch('admin/getTreeFolder');
      }
    },
    removeFolder: function(node){
      this.$store.dispatch('admin/removeTreeFolder', node);
    },
    handleCommand: function(command){
      if(command === "addFolder"){
        this.handleDialogOpen({type: 'addNodeFolder', data:this.selectedNode});
      }else if(command === "removeFolder"){
        this.removeFolder(this.selectedNode);
      }else if(command === "editFolder"){
        this.handleDialogOpen({type:'editNodeFolder', data:this.selectedNode});
      }
    },
    truncateFolderName: (str, n) => ((str.length > n) ? str.substr(0, n-1) + '...' : str),
    checkSubContent: function () {
      if(this.treeSubNodeData.data.length > 0 || this.bulbs.data.length > 0 || this.adminAjaxing || this.selectedNode.schoolId){
        return true;
      } return false;
    },
    checkTreeviewAddFolderPermission: function() {
      if(this.selectedNode.schoolId === this.school.master_district?.id) { 
        return true; 
      }
      return false;
    },
    checkTreeViewAccess: function(){
      return [12, 1167, 1762, 1179, 1965, 1966, 1967, 906].indexOf(this.school.id) >= 0;
    },
    exportInstructor: function(){
      this.$store.dispatch('admin/exportInstructorDataTable');
    },
    pasteSearch: function(event){
      if(event.clipboardData.getData('text/plain')){
        this.queryParamsAdmin.search = event.clipboardData.getData('text/plain');
        this.search();
      }
    },
    async calculateAdminFilterMenuNudgeLeft(event) {
      if (event?.contentType) this.adminFilterMenuContentType = event?.contentType;
      this.windowInnerWidth = window.innerWidth;
      if (!['Treeview', 'Bulbs'].includes(this.activeViewAdmin)) return;
      await this.$nextTick();
      if (this.windowInnerWidth <= 1053) {
        const adminFilterMenuContent = $(this.$refs?.adminFilterMenu?.$el).find('.v-menu__content');
        if (this.adminFilterMenuContentType !== 'Playlists') adminFilterMenuContent.height('50rem');
        else adminFilterMenuContent.height('');
        this.adminFilterMenuNudgeLeft = 450;
      } else {
        const adminFilterMenuContent = $(this.$refs?.adminFilterMenu?.$el).find('.v-menu__content');
        adminFilterMenuContent.height('');
        this.adminFilterMenuNudgeLeft = 330;
      }
    },
  },
  watch: {
    searchWatch: {
      //if search is reset, calls data refresh
      handler: function(val, oldVal){
        if(val === '' && oldVal != ''){
          this.search();
        }
      }
    },
    selectedDataAdmin(n, o) {
      if (n.length > 50 && ['Bulbs', 'Treeview'].includes(this.activeViewAdmin)) {
        this.triggerSnackbar({text:"Batch operations are limited to 50 bulbs at one time.", color: 'warning', timeout: 6000});
      }
    },
    activeViewAdmin(n,o) {
      this.calculateAdminFilterMenuNudgeLeft();
      if (n) this.adminFilterMenuNudgeLeft = 330;
    }
  },
  mounted() {
    EventBus.$on('admin-filter-menu-content-selection-change', this.calculateAdminFilterMenuNudgeLeft);
    this.calculateAdminFilterMenuNudgeLeft();
    window.addEventListener('resize', this.calculateAdminFilterMenuNudgeLeft);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateAdminFilterMenuNudgeLeft);
  },
};
</script>

<style scoped>
  .chip-container{
    height: 45px;
    background-color: #fff;
  }
  .nodeCard {
    padding: 5px !important;
  }
  .nodeCard {
    box-shadow: 0 1px 4px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 100%;
    border-radius: 5px;
  }
  .nodeCard:hover {
    box-shadow: 0 4px 6px 0 rgba(0,0,0,0.2);
  }
  .nodeContainer {
    padding: 2px 16px;
  }
  .treeViewButton {
    background-color: var(--branding-active-hex) !important;
    color:#ffffff !important;
  }
  .more-icon {
    padding-right:5px;
    font-size: 17px !important; 
  }
</style>


